import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'

export const Container = styled(Link)`
  ${({ theme }) => theme.textStyles.m375_tags}
  display: inline-flex;
  align-items: center;
  height: ${pxToRem(38)};
  padding-inline: ${pxToRem(16)};
  padding-block: ${pxToRem(8)};
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: ${pxToRem(48)};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.black};
  transition: border-color 0.2s ease-in-out;
  &:is(a[href]):hover,
  &:is(button):hover {
    border-color: rgba(0, 0, 0, 1);
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_tags}
  }
`
